import { useState } from "react";
import { login } from "../firebase/auth";
import { useNavigate } from "react-router-dom";
import { getDoc, doc } from "firebase/firestore";
import { auth, db } from "../firebase/config";
import { sendEmailVerification } from "firebase/auth";
import { Form, Button, Container, Alert, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Footer from "../ui/Footer";

function SimpleLogin() {
  const [email, setEmail] = useState(""); 
  const [password, setPassword] = useState(""); 
  const [message, setMessage] = useState(""); 
  const [reSendMessage, setResendMessage] = useState(""); // Resend email message state
  const [isLoading, setIsLoading] = useState(false); // Track loading state
  const [showPassword, setShowPassword] = useState(false); // Toggle password visibility
  const navigate = useNavigate(); 

  const handleLogin = async () => {
    setIsLoading(true); // Set loading state to true
    setMessage(""); // Reset the message before each attempt
    setResendMessage(""); // Reset the resend message before each attempt

    try {
      // Perform login
      const userCredential = await login(email, password);
      const user = userCredential.user;

      // Check if the email is verified
      if (!user.emailVerified) {
        setMessage("Please verify your email before logging in.");
        const confirmResend = window.confirm("Your email is not verified. Do you want to resend the verification email?");
        
        if (confirmResend) { 
          await sendEmailVerification(user); 
          setResendMessage("Verification email has been resent. Please check your inbox."); 
        } else {
          // User chose not to resend; prevent navigation to dashboard
          setIsLoading(false);
          return;
        }
      } 

      // Get the user's role from Firestore
      const userDoc = await getDoc(doc(db, "users", user.uid));

      if (userDoc.exists()) {
        const userData = userDoc.data();
        const userRole = userData.role || [];

        // Redirect based on user role
        if (userRole.includes("Faculty") && userData.approved) {
          navigate("/faculty/dashboard");  
        } else if (!userData.approved) {
          navigate("/WaitingForApproval");
        } else {
          navigate("/studentdashboard");
        }
      } else {
        setMessage("No user data found. Please contact support.");
      }
    } catch (error) {
      console.error("Login error:", error);

      // Detailed error handling
      if (error.code === "auth/invalid-credential") {
        setMessage("Incorrect email/password");
      } else {
        setMessage("An unknow error occurred. Please try again.")
      }
    } finally {
      setIsLoading(false); // Reset loading state
    }
  };

  return (
    <Container fluid className="login-container">
      <Row className="h-100">
        {/* Left side for the title */}
        <Col md={6} className="left-side d-flex align-items-center justify-content-center">
          <h1 className="title-text">Quiz Retake SignUp</h1>
        </Col>

        {/* Right side for the login form */}
        <Col md={6} className="right-side d-flex align-items-center justify-content-center">
          <div className="form-container">
            <h2 className="my-4 text-center">Login</h2>
            {message && <Alert variant="success">{message}</Alert>}
            {reSendMessage && <Alert variant="success">{reSendMessage}</Alert>} {/* Display resend message */}
            
            <Form onSubmit={(e) => e.preventDefault()}>
              <Form.Group controlId="email">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Form.Group>

              <Form.Group controlId="password">
                <Form.Label>Password</Form.Label>
                <div className="password-container">
                  <Form.Control
                    type={showPassword ? "text" : "password"} // Toggle password visibility
                    placeholder="Enter password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <Button
                    variant="link"
                    className="password-toggle-btn"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{ padding: 0, fontSize: "12px", color: "#000000", textDecoration: "none" }}
                  >
                    {showPassword ? "Hide" : "Show"} Password
                  </Button>
                </div>
              </Form.Group>

              <Button
                variant="success"
                type="submit"
                className="mt-9"
                onClick={handleLogin}
                disabled={isLoading} // Disable button while loading
              >
                {isLoading ? "Logging in..." : "Login"}
              </Button>
            </Form>

            <div className="my-4">
              <Link to="/RegisterAccount" className="text-decoration-none">Create Account</Link> | <Link to="/forgot/password" className="text-decoration-none">Forgot Password?</Link>
            </div>
          </div>
        </Col>
      </Row>
      <Footer />
    </Container>
  );
}

export default SimpleLogin;
